import LocalizedStrings from 'localized-strings';

import { TaskType } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    delete: 'Delete',
    fields: {
      description: 'Description (optional)',
      quantity: 'Quantity',
      title: 'Item title',
      titleEmpty: 'Please add a title to this item',
      type: 'Type',
      unitPrice: 'Unit price',
      vat: 'VAT',
    },
    sectionTitle: 'Items',
    type: {
      [TaskType.Product]: 'Product',
      [TaskType.Service]: 'Service',
    },
  },
  fr: {
    delete: 'Supprimer',
    fields: {
      description: 'Description (optionnelle)',
      quantity: 'Quantité',
      title: 'Titre de l’élément',
      titleEmpty: 'Précisez ce champ pour continuer',
      type: 'Type',
      unitPrice: 'Prix unit.',
      vat: 'TVA',
    },
    sectionTitle: 'Éléments',
    type: {
      [TaskType.Product]: 'Produit',
      [TaskType.Service]: 'Service',
    },
  },
} as const);

export default locales;
